<template>
  <div data-app>
    <div class="row mx-0 pt-3">
      <div class="col-md-7 pl-0 row mx-0">
        <div class="col-6 py-4 px-4 border_b_silver bg-white">
          <span class="card-label font-weight-bolder Main_Blue">Industry </span>
        </div>
        <div class="col-6 p-0 pt-3 text-end border_b_silver bg-white">
          <button
            type="button"
            class="custom-add-new-record-button btn_dash_ch mr-2"
            fab
            small
            @click="createFormEnable5"
          >
            <span class="v-btn__content" style="font-size: 14px !important"
              >Add new</span
            >
          </button>
        </div>
        <v-data-table
          :headers="headers5"
          :items="data5"
          item-key="job-function"
          class="elevation-1 px-4 rounded-0 headers_job_function_ch"
        >
          <template v-slot:item="props">
            <tr class="border__ch">
              <td
                class="Main_Blue"
                style="font-size: 14px; font-weight: 500 !important"
              >
                {{ props.item.industry_name }}
              </td>
              <td>
                <toggle-button
                  :value="props.item.status == '' + 1 ? true : false"
                  color="#82C7EB"
                  :sync="true"
                  :labels="false"
                  @change="changeStatus5(props.item)"
                />
                {{ props.item.status ? "Activated" : "Deactivated" }}
              </td>
              <td class="border-0" style="">
                <v-btn
                  class="py-2 ch_btn_silver_rounded_0"
                  fab
                  small
                  @click="editButtonClick5(props.item)"
                >
                  <img
                    src="\images/job_application/Edit_icon.svg"
                    alt=""
                    width="16"
                    height="16"
                  />
                </v-btn>
                <v-btn
                  class="py-2 ch_btn_silver_rounded_0"
                  fab
                  small
                  @click="askUserAboutDelete(props.item, 'industry')"
                >
                  <img
                    src="\images/job_application/Delete.svg"
                    alt=""
                    width="16"
                    height="16"
                  />
                </v-btn>
              </td>
            </tr>
            <tr>
              <td colspan="12" style="height: 12px"></td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="col-md-5 pl-0 pt-0">
        <!-- create form start -->
        <div class="col-12 py-4 px-4 border_b_silver bg-white">
          <span
            v-if="createForm5"
            class="card-label font-weight-bolder Main_Blue"
            >Add new Industry
          </span>
          <span
            v-if="updateForm5"
            class="card-label font-weight-bolder Main_Blue"
            >Update Industry
          </span>
        </div>
        <!-- create form start -->
        <div class="col-12 bg-white p-4">
          <!-- create form start -->
          <v-form
            ref="form"
            v-if="createForm5"
            v-model="valid5"
            lazy-validation
          >
            <v-text-field
              v-model="industry"
              :rules="nameRules5"
              label="Industry"
              required
            ></v-text-field>
            <button
              type="button"
              @click="createIndustry"
              class="custom-add-new-record-button btn_dash_ch mr-2"
            >
              <span
                class="v-btn__content px-4"
                style="font-size: 14px !important"
                >Save</span
              >
            </button>
          </v-form>
          <!-- create form end -->

          <!-- update form start -->
          <v-form
            ref="form"
            v-if="updateForm5"
            v-model="valid5"
            lazy-validation
          >
            <v-text-field
              v-model="industry"
              :rules="nameRules5"
              label="Industry"
              required
            ></v-text-field>
            <button
              type="button"
              @click="updateIndustry"
              class="custom-add-new-record-button btn_dash_ch mr-2"
            >
              <span
                class="v-btn__content px-4"
                style="font-size: 14px !important"
                >Update</span
              >
            </button>
            <v-btn
              style="padding: 8px !important"
              class="custom-add-new-record-button btn_red__ch"
              @click="cancel5"
            >
              Cancel
            </v-btn>
          </v-form>
          <!-- update form end -->
        </div>
      </div>
    </div>
    <!-- Confirm Delete Item -->

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-card-title>
            <span class="headline"
              >Do you really want to DELETE this item?</span
            >
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom-submit-button" text @click="dialog = false"
              >No</v-btn
            >
            <v-btn class="custom-cancel-button" text @click="deleteItem"
              ><b-spinner small type="grow" v-if="deleting"></b-spinner
              >Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/core/api";
import Swal from "sweetalert2";
import IndustryService from "@/MainServices/IndustryService.js";

export default {
  data() {
    return {
      loading5: true,
      // dialog: false,
      // deleteId: null,
      // deleting: false,
      success5: false,
      // token: `Bearer ${localStorage.getItem("token")}`,
      valid5: true,
      createForm5: true,
      updateForm5: false,
      industry: "",
      nameRules5: [
        (v) => !!v || "Industry is required",
        (v) =>
          (v && v.length <= 10) || "Industry must be less than 10 characters",
      ],
      headers5: [
        { text: "Industry", value: "industry_name" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
      ],
      data5: [],
    };
  },
  mounted() {var link = !!document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
    document.head.appendChild(link);
    this.getInititalData();
  },
  methods: {
    getInititalData() {
      IndustryService.getIndustries()
        .then((res) => {
          this.data5 = res.data;
          this.loading5 = false;
        })
        .catch(() => {
          this.loading5 = false;
        });
    },
    cancel5() {
      this.createForm5 = true;
      this.updateForm5 = false;
      this.industry = "";
    },
    createFormEnable5() {
      this.industry = "";
      this.createForm5 = true;
      this.updateForm5 = false;
    },

    createIndustry() {
      if (this.industry == "") {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      IndustryService.addNewIndustry({
        industry_name: this.industry,
      })
        .then((res) => {
          this.loading5 = false;
          this.success5 = true;
          this.industry = "";
          Swal.fire({
            title: "",
            text: "Industry type added",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel5();
        })
        .catch((error) => {
          this.loading5 = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    updateIndustry() {
      IndustryService.editIndustry(
        {
          industry_name: this.industry,
        },
        this.industry_id
      )
        .then((res) => {
          this.loading5 = false;
          this.success5 = true;
          this.industry = "";
          this.industry_id = "";
          Swal.fire({
            title: "",
            text: "Industry type updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel5();
        })
        .catch((error) => {
          this.loading5 = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    changeStatus5(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .put(`${API_URL}/industry/${item.id}`, {
          industry_name: item.industry_name,
          status: !item.status,
        })
        .then((res) => {
          this.loading5 = false;
          this.success5 = true;
          this.industry = "";
          this.industry_id = "";
          Swal.fire({
            title: "",
            text: "Status updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
          this.cancel5();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    editButtonClick5(item) {
      this.createForm5 = false;
      this.updateForm5 = true;
      this.industry = item.industry_name;
      this.industry_id = item.id;
    },

    deleteButtonClick5(item) {
      this.deleting = true;
      IndustryService.deleteIndustry(item)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "Industry type deleted",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.dialog = false;
          this.deleteId = null;
          this.deleting = false;
          this.getInititalData();
          this.loading5 = false;
        })
        .catch((error) => {
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.loading = false;
        });
    },

    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },

    deleteItem() {
      this.deleteButtonClick(this.deleteId);
    },
  },
};
</script>
